import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { OfflineBanner } from '../ui/OfflineBanner';
import { useLayoutStore } from '../../stores/layoutStore';

/**
 * Main layout component matching mockup-1 exactly.
 * Sprint 31.7: Rewritten to match mockup layout pattern using CSS classes.
 * Sprint 10.2: Added skip-to-content link for keyboard/screen-reader users (WCAG 2.4.1).
 * - Sidebar: fixed 260px, collapses with transform
 * - Topbar: sticky, padding-left shifts with sidebar collapse
 * - Main: margin-left 260px (0 when collapsed), max-width 1400px
 * 
 * Layout structure:
 * - .sidebar (fixed, z-100) - collapses off-screen
 * - .topbar (sticky, z-40) - padding adjusts
 * - .main (margin-left adjusts) - content area
 */
export function Layout() {
  const sidebarCollapsed = useLayoutStore((state) => state.sidebarCollapsed);

  return (
    <div className="min-h-screen">
      {/* Skip-to-content link — visible on focus, hidden otherwise (WCAG 2.4.1) */}
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>

      {/* Sidebar navigation - fixed position, collapses off-screen */}
      <Sidebar />
      
      {/* Main content area wrapper - margin-left adjusts with sidebar collapse */}
      <div className={`main-wrapper ${sidebarCollapsed ? 'expanded' : ''}`}>
        {/* Topbar - sticky header with hamburger and user info */}
        <Header />
        
        {/* Main content - matching mockup .main pattern */}
        <main id="main-content" className="main-content">
          <Outlet />
        </main>
      </div>

      {/* Global offline indicator - Sprint 31 */}
      <OfflineBanner />
    </div>
  );
}
